import React, { useContext, useEffect, useState } from "react";
import { OperationContext } from "../../CreateOperation";
import { useSearchParams } from "react-router";
import { ColumnItem } from "../../../../../../common/models/table";
import { PointingService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { LFTableV2 } from "../../../../../../common/components/LFTable/LFTableV2";
import { usePointingBoardingVehicleStore } from "../../../../store/PointingStore";
import { useOperationType } from "../../../../core/_context";

export const BoardingVehiclePointingList = () => {
  const { initialValue } = useContext(OperationContext);

  const { list, pageState, totalItems, setList, resetPageState, setPageState } =
    usePointingBoardingVehicleStore();
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const type = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const operationType = useOperationType();

  const cols: ColumnItem[] = [
    // {
    //   key: "inspectionDocksidePeriod",
    //   title: "Inspection à Quai",
    //   dataIndex: "inspectionDocksidePeriod",
    //   show: true,
    //   // isCanSort: true,
    // },

    {
      key: "pointingDocksidePeriod",
      title: "Pointage à Quai",
      dataIndex: "pointingDocksidePeriod",
      show: true,
      // isCanSort: true,
    },
    ...(operationType === "sales"
      ? [
          // {
          //   key: "inspectionOnBoardPeriod",
          //   title: "Inspection à Bord",
          //   dataIndex: "inspectionOnBoardPeriod",
          //   show: true,
          //   // isCanSort: true,
          // } as ColumnItem,
          {
            key: "pointingOnBoardPeriod",
            title: operationType === "sales" ? "Pointage à Bord" : "Pointage",
            dataIndex: "pointingOnBoardPeriod",
            show: true,
            // isCanSort: true,
          } as ColumnItem,
        ]
      : []),
  ];

  useEffect(() => {
    const selected =
      initialValue?.embarkationMovement?.loadPossessionStatus?.find(
        (item: any) => item.id === type?.toUpperCase()
      ) ?? initialValue?.embarkationMovement?.loadPossessionStatus?.[0];

    if (selected && selected?.url && movement) {
      getMovement(`${selected?.url}/controlled`, {
        ...pageState,
        "movement.id": movement,
        isLoadControlled: true,
      });
    }
  }, [movement, pageState, type]);

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await PointingService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <LFTableV2
        columns={cols}
        data={list}
        params={pageState}
        onAction={() => {}}
        permissions={["update"]}
        onSearch={setPageState}
        onSort={setPageState}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={setPageState}
      />
    </div>
  );
};
